// CancellationReasonService.tsx
import { BaseService } from '../../core/BaseService';
import { ChangeStatusRequest, PaginationParams } from '../../type';
import {
  CancellationReason,
  ChangeStatusCancellationReasonResponse,
  DeleteCancellationReasonResponse,
  GetCancellationReasonByIdResponse,
  GetCancellationReasonDropdownResponse,
  GetCancellationReasonResponse,
} from './interface';

export class CancellationReasonProfile extends BaseService {
  async createCancellationReason(req: CancellationReason) {
    return this.post<CancellationReason, CancellationReason>(`${this.apiUrl}/api/cancellationreasons`, req);
  }

  async getCancellationReason(params: PaginationParams) {
    return this.get<GetCancellationReasonResponse>(`${this.apiUrl}/api/cancellationreasons/paged`, params);
  }

  async getCancellationReasonDropdown(params: PaginationParams) {
    return this.get<GetCancellationReasonDropdownResponse>(`${this.apiUrl}/api/cancellationreasons/get`, params);
  }

  async updateCancellationReason(id: number, req: CancellationReason) {
    return this.put<CancellationReason, CancellationReason>(`${this.apiUrl}/api/cancellationreasons/${id}`, req);
  }

  async deleteCancellationReason(id: number) {
    return this.delete<DeleteCancellationReasonResponse>(`${this.apiUrl}/api/cancellationreasons/${id}`);
  }

  async changeStatusCancellationReason(id: number, active: string, req: ChangeStatusRequest) {
    return this.put<ChangeStatusCancellationReasonResponse, ChangeStatusRequest>(
      `${this.apiUrl}/api/cancellationreasons/${active}/${id}`,
      req
    );
  }

  async getCancellationReasonById(id: number | undefined) {
    return this.get<GetCancellationReasonByIdResponse>(`${this.apiUrl}/api/cancellationreasons/${id}`);
  }
}
